import { render, staticRenderFns } from "./ExerciseTestForm.vue?vue&type=template&id=084c2b93"
import script from "./ExerciseTestForm.vue?vue&type=script&lang=js"
export * from "./ExerciseTestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports